module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_help-c3812c74bc524179f4ccf5d2db7b3cbf.png";